import client from "./client";

const endpoint = '/tour-operators/'

export const getAllOperators = () => client.get(endpoint)